import { Pipe, PipeTransform } from "@angular/core";
import { OpenHouseRefreshmentOptions } from "../open-houses/models/OpenHouse";
import { listingStatusCodeToName } from "./interfaces/listing-status";

@Pipe({
	name: "translate",
})
export class TranslatePipe implements PipeTransform {
	translations = {
		...listingStatusCodeToName,
		SF: "Single Family",
		MF: "Multi-Family",
		LL: "Lots & Land",
		LLRLIT: "Lots & Land",
		CMU: "Commercial",
		RR: "Residential Rentals",
		FRM: "Farm",
		FRMRLIT: "Farm",
	};

	abbreviations = {
		PEND: "Pending",
		ACT: "Active",
		I: "Incomplete",
		CANCL: "Cancelled",
		CLOSD: "Sold",
		COMPS: "Comp Sold",
		CSN: "Coming Soon",
		D: "Delete",
		EXP: "Expired",
		ID: "Incomplete Deleted",
		OAA: "Office Approval Active",
		OAS: "Office Approval Comp Sold",
		OAW: "Office Approval Withheld",
		OACS: "Office Approval Coming Soon",
		RENTD: "Rented",
		TNAFS: "TNAFS",
		W: "Withheld",
		WD: "Withheld Deleted",
		WE: "Withheld Expired",
		SF: "Single Family",
		MF: "Multi-Family",
		LL: "Lots & Land",
		LLRLIT: "Lots & Land",
		CMU: "Commercial",
		RR: "Residential Rentals",
		FRM: "Farm",
		FRMRLIT: "Farm",
	};

	contingencies = {
		I: "Inspection",
		S: "Sale of Another Property",
		T: "Third Party Approval",
		F: "Subject to Financing",
		R: "Subject to Statutory Rescission",
		O: "Other",
		B: "With Bump Clause",
		X: "Without Bump Clause",
	};

	transform(value: string, args?: any): any {
		value = (value || "").toUpperCase();
		const translated = args
			? args.type === "icon"
				? this.iconUrl(value)
				: args.type === "contingency"
				? this.contingencies[value] || ""
				: args.type === "open-house"
				? OpenHouseRefreshmentOptions.find((o) => o.key === value)?.value || ""
				: this.abbreviations[value]
			: this.translations[value];
		return translated || value;
	}

	iconUrl(code?: string): string {
		const urls = {
			SF: "assets/images/svg/Single_Family.svg",
			MF: "assets/images/svg/Multi_Family.svg",
			RR: "assets/images/svg/Residential_Rentals.svg",
			LL: "assets/images/svg/LotsAndLand.svg",
			LLRLIT: "assets/images/svg/LotsAndLand.svg",
			CMU: "assets/images/svg/Commercial.svg",
			FRM: "assets/images/svg/Farm.svg",
			FRMRLIT: "assets/images/svg/Farm.svg",
		};
		return urls[code];
	}
}
